import { keepPreviousData, useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { QuotaOperationState } from "../types";

import { quotaQueryKeys } from "./keys";
import { useDataCreditsQuery } from "./useDataCreditsQuery";

export const useExportQuotaQuery = (enabled: boolean = true) => {
    const isDataCreditsEnabled = salesSettingsHelper.isDataCreditsEnabled;

    const dataCreditsQuery = useDataCreditsQuery({ select: (data) => data.exportsState });

    const legacyQuery = useQuery<QuotaOperationState>({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: quotaQueryKeys.excelQuota(),
        placeholderData: keepPreviousData,
        enabled: enabled && !isDataCreditsEnabled,
        queryFn({ signal }) {
            return salesApiService.quota.fetchExcelQuota({ cancellation: signal });
        },
    });

    return isDataCreditsEnabled ? dataCreditsQuery : legacyQuery;
};
